<ng-container *ngIf="initialised">
  <app-header></app-header>

  <main [class.mobile-navigation-active]="mobileNavigationActive$ | async">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</ng-container>
